import { createConnectQuery } from '../createConnectQuery'
import { getPath } from '@jotta/grpc-connect-openapi/fileQuery'

export const useGetPath = createConnectQuery(getPath)
